"use strict";

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyDiff = exports.diffItems = exports.splitChanges = exports.ChangeType = void 0;

var lodash_1 = require("lodash");

var unique_1 = require("./unique");

var ChangeType;

(function (ChangeType) {
  ChangeType["Addition"] = "A";
  ChangeType["Update"] = "U";
  ChangeType["Delete"] = "D";
  ChangeType["Reorder"] = "R";
})(ChangeType || (exports.ChangeType = ChangeType = {}));

function splitChanges(changes) {
  return (0, lodash_1.groupBy)(changes, 'type');
}

exports.splitChanges = splitChanges;

function diffItems(from, to) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      order = _ref.order;

  var dFrom = (0, unique_1.mergeDuplicateItems)(from);
  var dTo = (0, unique_1.mergeDuplicateItems)(to);
  var added = dTo.filter(function (item) {
    return !dFrom.some(function (f) {
      return f.id === item.id;
    });
  }) || [];
  var removed = dFrom.filter(function (item) {
    return !dTo.some(function (t) {
      return t.id === item.id;
    });
  }) || [];
  var changed = dTo.filter(function (item) {
    var fromItem = dFrom.find(function (f) {
      return f.id === item.id;
    });
    return fromItem !== null && fromItem !== undefined && !(0, lodash_1.isEqual)(item, fromItem);
  }) || [];
  var reorderItem = undefined;

  if (order) {
    var orderChanged = dTo.some(function (item, index) {
      var fromItem = dFrom[index];
      return fromItem !== null && fromItem !== undefined && fromItem.id !== item.id;
    });

    if (orderChanged) {
      reorderItem = {
        type: ChangeType.Reorder,
        sortedIds: dTo.map(function (item) {
          return item.id;
        })
      };
    }
  }

  return [].concat(_toConsumableArray(added.map(function (add) {
    return {
      type: ChangeType.Addition,
      item: add
    };
  })), _toConsumableArray(changed.map(function (change) {
    return {
      type: ChangeType.Update,
      item: change
    };
  })), _toConsumableArray(removed.map(function (remove) {
    return {
      type: ChangeType.Delete,
      id: remove.id
    };
  })), _toConsumableArray(reorderItem ? [reorderItem] : []));
}

exports.diffItems = diffItems;

function applyDiff(existing, changes) {
  var realExisting = (0, unique_1.mergeDuplicateItems)(existing);

  var _splitChanges = splitChanges(changes || []),
      additions = _splitChanges.A,
      deletions = _splitChanges.D,
      updates = _splitChanges.U,
      reorder = _splitChanges.R;

  var result = realExisting.filter(function (existingItem) {
    return !(deletions === null || deletions === void 0 ? void 0 : deletions.some(function (deletion) {
      return deletion.id === existingItem.id;
    }));
  }).map(function (existingItem) {
    var update = updates === null || updates === void 0 ? void 0 : updates.find(function (update) {
      return update.item.id === existingItem.id;
    });
    return update ? update.item : existingItem;
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var addition = _step.value;
      var existingIndex = result.findIndex(function (item) {
        return item.id === addition.item.id;
      });

      if (existingIndex !== -1) {
        result[existingIndex] = addition.item;
      } else {
        result.push(addition.item);
      }
    };

    for (var _iterator = (additions || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (reorder === null || reorder === void 0 ? void 0 : reorder.length) {
    if (reorder.length !== 1) throw new Error('There can only be 1 reorder item when applying a diff.');
    var sortedIds = reorder[0].sortedIds;
    return sortedIds.map(function (id) {
      return result.find(function (item) {
        return item.id === id;
      });
    }).filter(Boolean);
  } else return result;
}

exports.applyDiff = applyDiff;